import CartOption from './cart-option'
import CartProduct from './cart-product'
import OatPrice from '../price'

export default class CartItem {
  constructor({ id, product, quantity, options, unitPrice = null, optionsPrice = null, isNew = false }) {
    this.id = id;
    this.product = product;
    this.quantity = quantity;
    this.options = options;

    this.unitPrice = unitPrice;
    this.optionsPrice = optionsPrice;

    this.isNew = isNew;
  }

  get selectedOptions() { 
    let ret = [];
    if(!this.isNew) {
      ret = this.options.map((option) => option.toString());
    } else {
      ret = this.options.map((option) => option.toStringNew());
    }

    return ret;
  }

  get total() { 
    let ret = 0;

    if(this.isNew) {
      let price = 0; 
      let promo = null;

      price = this.product.total.value;
      
      if(![null, false, undefined].includes(this.product.promo.value)) {
        promo = this.product.promo.value;
      }

      this.options.forEach(opt => {
        if(promo !== null){
          promo += opt.total;
        }
        
        price += opt.total;
      });

      ret = { price: { value: price * this.quantity }, promo: { value: promo !== null ? promo * this.quantity : null } };
    } else {
      ret = { price: { value: (this.unitPrice + this.optionsPrice) * this.quantity }};
    }

    return ret;
  }

  toCheckout() {
    return {
      product_id: this.product.id,
      variant_id: this.product.variant.id,
      options: this.options.map(opt => opt.toCheckout()),
      quantity: this.quantity
    }
  }

  validate() { 
    let ret = true;

    if(this.isNew) {
      this.options.forEach(option => {
        ret = !ret ? ret : option.validate();
      });
    }

    return ret;
  }

  static create({ product, options, quantity }) {
    const variant = {
      id: product.variants[0].id,
      name: product.variants[0].title,
      sku: product.variants[0].sku,
      price: new OatPrice({ prices: [product.variants[0].unit_price] })
    };

    const p = new CartProduct({ 
      id: product.id,
      name: product.name,
      promo: product.promoPrice,
      variant: variant
    });

    const opts = options.map(option => {
      return new CartOption({
        code: option.code,
        id: option.id,
        name: option.name,
        price: option.basePrice,
        required: option.required,
        min: option.min,
        max: option.max,
        value: null,
        values: option.values,
      });
    });

    return new CartItem({
      product: p, 
      options: opts, 
      quantity: quantity,
      isNew: true
    });
  }

  static fromJSON(json) {
    const product = new CartProduct(CartProduct.fromJSON(json)); 
    const options = json.options.map(option => {
      return new CartOption(CartOption.fromJSON(option, json))
    });

    return {
      id: json.id,
      product, 
      quantity: json.quantity,
      unitPrice: json.computed_unit_price,
      optionsPrice: json.computed_options_price,
      options
    }
  }
}